import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { TfiReload } from "react-icons/tfi";
import { LoginContext } from "../../../context/LoginContext";
import { useNavigate } from "react-router-dom"
import NoDataImage from "../../../background.gif";
import ProfileMemberCard from "../../common/ProfileMemberCard";




const FilterCardGallery = () => {

  const { isLoggedIn, userId, userData, setUserdata, isPremium } = useContext(LoginContext);
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("desiredPartners");
  const [recentlyUsers, setrecentlyUsers] = useState([]);
  const [matchedUser, setmatchedUser] = useState([]);
  const [interestUsers, setinterestUsers] = useState([]);
  const [desiredUsers, setdesiredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [load, setLoad] = useState({ start: 0, end: 8 });
  const [matched, setmatched] = useState({ start: 0, end: 8 });
  const [interest, setinterest] = useState({ start: 0, end: 8 });
  const [desired, setdesired] = useState({ start: 0, end: 8 });

  useEffect(() => {

    if (!isLoggedIn || !userId) {
      navigate("/login");
      return;
    }

    const buildPayload = (profile) => {
      const payload = new FormData();
      payload.append("id", userId);
      payload.append("looking", profile.looking_for || userData.looking_for || "");
      payload.append("looking_for", profile.looking_for || userData.looking_for || "");
      payload.append("gender", profile.gender || userData.gender || "");
      payload.append("status", profile.status ?? userData.status ?? 1);
      payload.append("email", profile.email || userData.email || "");
      payload.append("limit", 40);
      return payload;
    };

    const loadAllMatches = async () => {
      setLoading(true);
      try {
        let profile = { ...userData };

        // Refresh full profile so gender / looking_for are always available
        try {
          const profilePayload = new FormData();
          profilePayload.append("id", userId);
          profilePayload.append("find_id", userId);
          profilePayload.append("status", userData.status ?? 1);
          profilePayload.append("looking_for", userData.looking_for || "");
          profilePayload.append("gender", userData.gender || "");
          profilePayload.append("email", userData.email || "");

          const profileRes = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}mycon/view_profile`,
            profilePayload
          );

          if (profileRes.data?.details) {
            profile = {
              ...userData,
              ...profileRes.data.details,
              user_id: profileRes.data.details.user_id || userId,
              pp: profileRes.data.details.image1 || userData.pp,
            };
            setUserdata(profile);
          }
        } catch (err) {
          console.log("Profile refresh skipped", err);
        }

        if (!profile.gender || !profile.looking_for) {
          console.error("Missing gender/looking_for for match fetch", profile);
          setdesiredUsers([]);
          setrecentlyUsers([]);
          setmatchedUser([]);
          setinterestUsers([]);
          return;
        }

        const payload = buildPayload(profile);

        const [desiredRes, interestRes, recentRes, matchedRes] = await Promise.allSettled([
          axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/desire_patner_match`, payload),
          axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/send_interest`, payload),
          axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/recently_joint_match`, payload),
          axios.post(`${process.env.REACT_APP_API_BASE_URL}mycon/matched_interest`, payload),
        ]);

        let desiredList = [];
        if (desiredRes.status === 'fulfilled' && Array.isArray(desiredRes.value.data?.matched)) {
          desiredList = desiredRes.value.data.matched;
        }

        let recentList = [];
        if (recentRes.status === 'fulfilled' && Array.isArray(recentRes.value.data?.recently)) {
          recentList = recentRes.value.data.recently;
        }

        // Always show cards: if desired is empty, use recently joined
        if (!desiredList.length && recentList.length) {
          desiredList = recentList;
        }

        setdesiredUsers(desiredList);
        setrecentlyUsers(recentList);

        if (interestRes.status === 'fulfilled' && Array.isArray(interestRes.value.data?.connection)) {
          setinterestUsers(interestRes.value.data.connection);
        } else {
          setinterestUsers([]);
        }

        if (matchedRes.status === 'fulfilled' && Array.isArray(matchedRes.value.data?.matched)) {
          setmatchedUser(matchedRes.value.data.matched);
        } else {
          setmatchedUser([]);
        }
      } catch (error) {
        console.error("There was an error fetching users!", error);
      } finally {
        setLoading(false);
      }
    };

    loadAllMatches();
  }, [isLoggedIn, userId]);

  // (age/height formatting lives in ProfileMemberCard)

  const handleLoadMore = (data, setdata, api) => {
    setdata({ start: 0, end: (data.end + 8) });
    if ((data.end) > (api.length - 1)) {
      setdata({ start: 0, end: (api.length) });
    }
  };


  // Filter users based on active filter
  const filterData = {
    desiredPartners: desiredUsers.slice(desired.start, desired.end),
    recentlyJoined: recentlyUsers.slice(load.start, load.end),
    matchedProfiles: matchedUser.slice(matched.start, matched.end),
    recentlySentInterest: interestUsers.slice(interest.start, interest.end),
  };

  const activeList = filterData[activeFilter] || [];

  const emptyMessages = {
    desiredPartners: "No Desired Partner Found",
    matchedProfiles: "No Matched Profiles Found",
    recentlySentInterest: "No Sent Interest",
    recentlyJoined: "No Recently Joined Members",
  };

  return (
    <div className="filter-card-gallery">
      <div className="content-wrapper">
        <div className="filter-buttons justify-content">

          <button
            className={activeFilter === "desiredPartners" ? "active" : ""}
            onClick={() => setActiveFilter("desiredPartners")}
          >
            Desired Partner
          </button>
          <button
            className={activeFilter === "matchedProfiles" ? "active" : ""}
            onClick={() => setActiveFilter("matchedProfiles")}
          >
            Matched Profiles
          </button>
          <button
            className={activeFilter === "recentlySentInterest" ? "active" : ""}
            onClick={() => setActiveFilter("recentlySentInterest")}
          >
            Sent Interest
          </button>
          <button
            className={activeFilter === "recentlyJoined" ? "active" : ""}
            onClick={() => setActiveFilter("recentlyJoined")}
          >
            Recently Joined
          </button>
        </div>

        {loading ? (
          <div className='custom-loader-g'><div className="spinner-border text-danger" role="status"><span className="sr-only">Loading...</span></div></div>)
          : (<div className="cards-grid" style={{ display: (activeList.length < 1) ? ("block") : "grid" }} >
            {activeList.map((member) => (
              <ProfileMemberCard
                key={member.user_id}
                member={member}
                to={isPremium ? `/view-profile/${member.user_id}` : `/upgrade/${userId}`}
              />
            ))}
            {(activeList.length < 1) ? (<div className='position-relative nodataBox w-100 h-100' style={{ backgroundImage: `url(${NoDataImage})` }}><div><h2 className={'text-white fw-bold text-center'}>{emptyMessages[activeFilter] || "No Match Found"}</h2></div></div>) : ""}
          </div>
          )}


        {(activeFilter === "desiredPartners") && (desiredUsers.length > 8 && desired.end != desiredUsers.length) && <p className="text-center load-more-wrap">
          <button onClick={() => handleLoadMore(desired, setdesired, desiredUsers)} className="btn btn-outline-danger load-more-btn"> <TfiReload /> Load More Desired Profiles</button>
        </p>}

        {(activeFilter === "recentlyJoined") && (recentlyUsers.length > 8 && load.end != recentlyUsers.length) && <p className="text-center load-more-wrap">
          <button onClick={() => handleLoadMore(load, setLoad, recentlyUsers)} className="btn btn-outline-danger load-more-btn"> <TfiReload /> Load More Profiles</button>
        </p>}


        {(activeFilter === "matchedProfiles") && (matchedUser.length > 8 && matched.end != matchedUser.length) && <p className="text-center load-more-wrap">
          <button onClick={() => handleLoadMore(matched, setmatched, matchedUser)} className="btn btn-outline-danger load-more-btn"> <TfiReload /> Load More Matched Profiles</button>
        </p>}

        {(activeFilter === "recentlySentInterest") && (interestUsers.length > 8 && interest.end != interestUsers.length) && <p className="text-center load-more-wrap">
          <button onClick={() => handleLoadMore(interest, setinterest, interestUsers)} className="btn btn-outline-danger load-more-btn"> <TfiReload /> Load More recently Sent Interest</button>
        </p>}
      </div>

      <style>{`
        .filter-card-gallery button,
        .filter-card-gallery section,
        .filter-card-gallery div,
        .filter-card-gallery p,
        .filter-card-gallery h5,
        .filter-card-gallery span {
          text-transform: capitalize;
        }

        .filter-card-gallery .member-info h5,
        .filter-card-gallery .member-id {
          color: white !important;
          text-align: center !important;
        }

        .filter-card-gallery .hs-vitem__label {
          text-transform: none !important;
        }

        .filter-card-gallery {
          padding: 20px;
          max-width: 1400px;
          margin: 0 auto;
          width: 100%;
          box-sizing: border-box;
          overflow-x: hidden;
        }

        .filter-card-gallery .content-wrapper {
          background: white;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
          overflow: hidden;
        }

        .filter-card-gallery .filter-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          padding: 20px;
          border-bottom: 1px solid #eee;
          justify-content: center;
        }

        .filter-card-gallery .filter-buttons button {
          padding: 8px 20px;
          border-radius: 20px;
          border: 1px solid #e53d5c;
          background: white;
          color: #e53d5c;
          cursor: pointer;
          font-size: 14px;
          transition: all 0.3s;
        }

        .filter-card-gallery .filter-buttons button.active {
          background: #e53d5c;
          color: white;
        }

        .filter-card-gallery .cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
          gap: 20px;
          padding: 20px;
        }

        .filter-card-gallery .member-card {
          height: 100%;
        }

        .filter-card-gallery .nodataBox {
          min-height: 360px;
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
        }

        .filter-card-gallery .custom-loader-g {
          display: flex;
          justify-content: center;
          padding: 60px;
        }

        .filter-card-gallery .load-more-wrap {
          padding: 8px 16px 24px;
          margin: 0;
        }

        .filter-card-gallery .load-more-btn {
          max-width: 100%;
          white-space: normal;
          line-height: 1.35;
        }

        @media (max-width: 992px) {
          .filter-card-gallery .cards-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 16px;
            padding: 16px;
          }
        }

        @media (max-width: 768px) {
          .filter-card-gallery {
            padding: 12px 10px 20px;
            padding-bottom: max(20px, env(safe-area-inset-bottom));
          }

          .filter-card-gallery .content-wrapper {
            border-radius: 10px;
          }

          .filter-card-gallery .filter-buttons {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 8px;
            padding: 12px;
          }

          .filter-card-gallery .filter-buttons button {
            width: 100%;
            padding: 10px 8px;
            font-size: 12px;
            line-height: 1.25;
            border-radius: 14px;
            min-height: 44px;
          }

          .filter-card-gallery .cards-grid {
            grid-template-columns: 1fr;
            gap: 16px;
            padding: 12px;
            max-width: 420px;
            margin: 0 auto;
          }

          .filter-card-gallery .load-more-btn {
            width: 100%;
            padding: 12px 16px;
          }

          .filter-card-gallery .nodataBox {
            min-height: 280px;
            margin: 0 12px 12px;
          }
        }

        @media (max-width: 380px) {
          .filter-card-gallery .filter-buttons button {
            font-size: 11px;
            padding: 8px 6px;
          }
        }
      `}</style>
    </div>
  );
};

export default FilterCardGallery;
